import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=1241c1c8&"
import script from "./TaskDetail.vue?vue&type=script&lang=js&"
export * from "./TaskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports